import React from 'react';

type Props = {
  className?: string;
};

const Chat: React.FC<Props> = ({ className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.9997 9.76344C14.0238 9.72875 14.0469 9.69281 14.0707 9.65906C14.6751 8.76079 14.9985 7.70299 14.9997 6.62031C15.0097 3.51719 12.3916 1 9.1541 1C6.33035 1 3.97473 2.92156 3.42285 5.4725C3.34006 5.85056 3.29816 6.23642 3.29785 6.62344C3.29785 9.72969 5.81535 12.3144 9.05285 12.3144C9.56754 12.3144 10.261 12.1597 10.6413 12.0553C11.0216 11.9509 11.3985 11.8131 11.496 11.7759C11.5935 11.7387 11.746 11.7006 11.8675 11.7356L14.2869 12.435C14.3082 12.4413 14.3307 12.4418 14.3523 12.4365C14.3738 12.4312 14.3935 12.4202 14.4095 12.4048C14.4254 12.3893 14.4369 12.3699 14.4428 12.3485C14.4487 12.3271 14.4488 12.3046 14.4432 12.2831L13.8894 10.1741C13.851 10.0178 13.846 9.98844 13.9997 9.76344Z"
        className="fill-primary"
      />
      <path
        d="M9.76691 12.9806C9.52643 13.0191 9.28353 13.0405 9.04004 13.0447C7.7141 13.0447 6.46191 12.6947 5.44629 12.0384C4.79661 11.6397 4.23267 11.1158 3.78722 10.4972C2.97222 9.41686 2.52785 8.04373 2.52785 6.60686C2.52785 6.50904 2.53129 6.41498 2.53472 6.32061C2.53596 6.29277 2.5286 6.26524 2.51363 6.24174C2.49867 6.21823 2.47683 6.19991 2.45109 6.18926C2.42534 6.17861 2.39695 6.17614 2.36975 6.1822C2.34256 6.18825 2.31789 6.20254 2.2991 6.22311C1.55083 7.04183 1.09849 8.08767 1.01431 9.19362C0.930138 10.2996 1.21898 11.4018 1.83472 12.3244C1.91191 12.4422 1.95566 12.5331 1.94222 12.5937L1.50191 14.8519C1.49785 14.8733 1.49949 14.8955 1.50666 14.9161C1.51384 14.9368 1.5263 14.9552 1.5428 14.9695C1.55931 14.9838 1.57928 14.9936 1.60073 14.9978C1.62218 15.002 1.64435 15.0005 1.66504 14.9934L3.79004 14.2359C3.85448 14.2104 3.92331 14.1979 3.9926 14.1991C4.06188 14.2003 4.13025 14.2151 4.19378 14.2428C4.82972 14.4928 5.53316 14.6465 6.2366 14.6465C7.5906 14.651 8.89485 14.1366 9.88129 13.209C9.90165 13.1892 9.91518 13.1634 9.9199 13.1353C9.92463 13.1073 9.92031 13.0785 9.90758 13.053C9.89485 13.0276 9.87436 13.0069 9.84907 12.9939C9.82378 12.9808 9.79501 12.9762 9.76691 12.9806Z"
        className="fill-primary"
      />
    </svg>
  );
};

export default Chat;
